import { registerPlugin } from '@capacitor/core';
const LpapiPlugin = registerPlugin('LpapiPlugin', {
    web: () => import('./web').then(m => new m.LpapiPluginWeb()),
});
export * from './definitions';
export { LpapiPlugin };
//# sourceMappingURL=index.js.map